import React from 'react';
import {View} from 'react-native';
import {useDispatch} from 'react-redux';
import i18n from 'i18n-js';
import ConfirmTrackingNumber from '../scanpack/confirmTrackingNumber';
import {CallPostScanModule} from '../../actions/scanpackAction';

const MODULE_NAMES = {
  record: 'record_tracking_number',
  verify: 'verify_shipping_label'
};

const PostScanTrackingPrompt = ({
  mode, // 'record' | 'verify'
  orderId,
  orderNumber,
  hasTracking = false,
  value = '',
  onChangeText,
  onComplete
}) => {
  const dispatch = useDispatch();
  const isRecord = mode === 'record';

  const onSubmitEditing = () => {
    // Verify with no tracking number on the order → bypass with a null input.
    const moduleInput = isRecord || hasTracking ? value : null;
    dispatch(
      CallPostScanModule(MODULE_NAMES[mode], orderId, moduleInput, null, null, data => {
        if (typeof onComplete === 'function') onComplete(data);
      })
    );
  };

  const fieldLabel = isRecord
    ? 'Tracking Number Recording'
    : 'Shipping Label Verification';
  const messageDetail = isRecord
    ? i18n.t('recordTracingmsg.createShippingLabel')
    : hasTracking
    ? i18n.t('shippinglabelmsg.scanShippingLabel')
    : i18n.t('shippinglabelmsg.noRecordTracking');

  return (
    <View
      style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999}}
    >
      <ConfirmTrackingNumber
        postScanningFieldLabel={fieldLabel}
        postScanningOrderNumber={orderNumber}
        statecheck={isRecord ? false : !hasTracking}
        scanPackSetting={{}}
        alertBoxTracking={false}
        alertBoxShipping={false}
        postScanningMessageDetail={messageDetail}
        trackingOrderInput={value}
        onChangeText={onChangeText}
        onSubmitEditing={onSubmitEditing}
        order={{
          order: {
            tracking_num: isRecord ? value || '' : hasTracking ? 'present' : ''
          }
        }}
      />
    </View>
  );
};

export default PostScanTrackingPrompt;
